import { render } from "./doughnut-chart.vue?vue&type=template&id=41e37b0e&scoped=true&ts=true"
import script from "./doughnut-chart.vue?vue&type=script&lang=ts"
export * from "./doughnut-chart.vue?vue&type=script&lang=ts"

import "./doughnut-chart.vue?vue&type=style&index=0&id=41e37b0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e37b0e"]])

export default __exports__